import { AAGUID } from '@interticket/core';
import { ISelectEventRequest } from '@core/interfaces/cart/select-event-request.interface';

export class SelectEventRequest implements ISelectEventRequest {

  readonly eventId: AAGUID;
  readonly priceCategoryId: AAGUID;
  readonly quantity: number;
  readonly knownPrice: number;

  constructor(iSelectEventRequest: ISelectEventRequest) {
    this.eventId = iSelectEventRequest.eventId;
    this.priceCategoryId = iSelectEventRequest.priceCategoryId;
    this.quantity = iSelectEventRequest.quantity;
    this.knownPrice = iSelectEventRequest.knownPrice;
  }

}
